export default {
  FIR: "雷鸟Air 固件升级",
  NO: "暂不支持移动端固件升级",
  TIPS: "请在电脑上使用以下浏览器进行固件升级",
};
